import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import axiosInstance from '../../api/axiosInstance';
// Define async thunk for submitting the form
export const submitNewOrderRequest = createAsyncThunk(
    'order/submitNewOrderRequest',
    async ({formData ,token} ,{ rejectWithValue }) => {                
        try {
            const response = await axiosInstance.post('/api/Customer/RequestNewOrder', formData , {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${token}`,
                },
            });
            return response.data;  // Return success response
        } catch (error) {
            return rejectWithValue(error.response.data);  // Return error if API fails
        }
    }
);

// Create the slice with renamed state properties
const orderSlice = createSlice({
    name: 'order',
    initialState: {
        isSubmitting: false,  // Renamed from `loading`
        isSuccessful: false,  // Renamed from `success`
        errorMessage: null,   // Renamed from `error`
        responseData: null,   // Renamed from `data`
    },
    reducers: {
        resetOrderState: (state) => {
            state.isSuccessful = false;
            state.errorMessage = null;
            state.responseData = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(submitNewOrderRequest.pending, (state) => {
                state.isSubmitting = true;
            })
            .addCase(submitNewOrderRequest.fulfilled, (state, action) => {
                state.isSubmitting = false;
                state.isSuccessful = true;
                state.responseData = action.payload;  // Store response data
            })
            .addCase(submitNewOrderRequest.rejected, (state, action) => {
                state.isSubmitting = false;
                state.errorMessage = action.payload;  // Store error response
            });
    },
});

export const { resetOrderState } = orderSlice.actions;

export default orderSlice.reducer;
